import { put, takeLatest, call } from "redux-saga/effects";
import * as types from "../../actionTypes";
import AxiosInstance from "../../../services/AxiosInstance";
import { showToast } from "../../../Components/Common/Toast";
import { deleteResumeFailure, deleteResumeSuccess } from "./actions";

function* updateAvatar(action) {
  try {
    const response = yield call(() =>
      AxiosInstance().post("/jobseeker/add_update_photo", action.payload)
    );
    console.log("updatePersonalInfo", response);
    if (response.data.status) {
      yield put({
        type: types.UPDATE_JOBSEEKER_AVATAR_SUCCESS,
        payload: response.data,
      });
    } else {
      yield put({
        type: types.UPDATE_JOBSEEKER_AVATAR_FAILURE,
        payload: response.data,
      });
    }
  } catch (error) {
    yield put({
      type: types.UPDATE_JOBSEEKER_AVATAR_FAILURE,
      payload: { status: false, message: error.message },
    });
  }
}

function* avatarSaga() {
  yield takeLatest(types.UPDATE_JOBSEEKER_AVATAR, updateAvatar);
}

export default avatarSaga;
